module.exports = __webpack_public_path__ + "img/gywmdb.5924508a.png";